import { MemberUser } from './member-user';
import { OrgNode } from './org-node';
import { FiscalYear } from './fiscal-year';
import { Permission } from './permission';
import { PermissionType } from './permission-type';

export class MemberUserPermission{
    public MemberUserPermissionId:string;
    public MemberUserId:string;
    public OrgNodeId:string;
    public FiscalYearId:number;
    public PermissionId:number;
    public PermissionTypeId:number;

    public MemberUser:MemberUser;
    public OrgNode:OrgNode;
    public FiscalYear:FiscalYear;
    public Permission:Permission;
    public PermissionType:PermissionType;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/member-user-permission.ts